import { RESET_GLOBAL_DIALOG } from '@glass/web/modules/globalDialog';

const resetGlobalDialogAction = () => ({
  type: RESET_GLOBAL_DIALOG,
});

export default resetGlobalDialogAction;
